import {useEffect, useState} from 'react';

const AFTERPAY_SCRIPT_ATTR = 'data-kl-afterpay-widget';
const ZIP_SCRIPT_ATTR = 'data-kl-zip-widget';

let afterpayLoadPromise = null;

function loadAfterpayScript({url, min, max}) {
  if (typeof document === 'undefined') return Promise.resolve();
  if (afterpayLoadPromise) return afterpayLoadPromise;

  afterpayLoadPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[${AFTERPAY_SCRIPT_ATTR}]`);

    if (existing) {
      resolve();

      return;
    }

    const script = document.createElement('script');

    script.src = url;
    script.async = true;
    script.setAttribute(AFTERPAY_SCRIPT_ATTR, 'true');
    script.setAttribute('data-min', min);
    script.setAttribute('data-max', max);
    script.onload = () => resolve();
    script.onerror = () => {
      afterpayLoadPromise = null;
      reject(new Error(`Failed to load ${url}`));
    };
    document.head.appendChild(script);
  });

  return afterpayLoadPromise;
}

export function useAfterpayScript(enabled, {url, min, max}) {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (!enabled || !url) return undefined;

    let cancelled = false;

    loadAfterpayScript({url, min, max})
      .then(() => {
        if (!cancelled) setIsReady(true);
      })
      .catch(() => {
        if (!cancelled) setIsReady(false);
      });

    return () => {
      cancelled = true;
    };
  }, [enabled, url, min, max]);

  return {isReady};
}

export function useZipScriptRescan(enabled, url) {
  useEffect(() => {
    if (!enabled || !url || typeof document === 'undefined') return undefined;

    const frame = window.requestAnimationFrame(() => {
      const existing = document.querySelector(`script[${ZIP_SCRIPT_ATTR}]`);

      if (existing) {
        existing.remove();
      }

      const script = document.createElement('script');

      script.src = url;
      script.async = true;
      script.setAttribute(ZIP_SCRIPT_ATTR, 'true');
      document.head.appendChild(script);
    });

    return () => {
      window.cancelAnimationFrame(frame);
    };
  }, [enabled, url]);
}
